import { z } from 'zod'

import { WEEKDAYS } from '@/utils/time.utils'

const ProfileDataCommonFields = z.object({
  inReview: z.boolean(),
  store_name: z.string().min(1, { message: 'Required' }),
  email1: z.string().min(1, { message: 'Required' }),
  email2: z.string().nullable(),
  facebook: z.string().optional(),
  website: z.string().optional(),
  genre: z.string().optional(),
  address: z.string(),
  avg_ratings: z.number(),
  support: z.object({
    code: z.string().nullable(),
    number: z.string().nullable()
  })
})

export const editStoreInfoFormSchema = ProfileDataCommonFields.extend({
  phone1: z.string().nullable(),
  phone2: z.string().nullable(),
  phone3: z.string().nullable(),
  store_img_name: z.union([z.string(), z.instanceof(File), z.null()])
})

const ApiProfileDataSchema = ProfileDataCommonFields.extend({
  phone: z.object({
    phone1: z
      .object({
        country_code: z.string().nullable().optional(),
        number: z.string().nullable().optional()
      })
      .optional(),
    phone2: z
      .object({
        country_code: z.string().nullable().optional(),
        number: z.string().nullable().optional()
      })
      .optional(),
    phone3: z
      .object({
        country_code: z.string().nullable().optional(),
        number: z.string().nullable().optional()
      })
      .optional()
  }),
  store_img_name: z.string().nullable().optional()
})

const ApiGetProfileResponseSchema = z.object({
  profileData: ApiProfileDataSchema,
  status: z.string(),
  message: z.string()
})

const ApiTimeRange = z.object({
  start_time: z.number().nullable(),
  end_time: z.number().nullable()
})

const ApiBusinessDay = z
  .object({
    day_name: z.enum(WEEKDAYS),
    isWorking: z.boolean(),
    slots: z.array(ApiTimeRange)
  })
  .merge(ApiTimeRange)

const ApiBusinessDayResponse = z.object({
  day_name: z.enum(WEEKDAYS),
  start_time: z.number(),
  end_time: z.number()
})

const ApiGetBusinessHoursSchema = z.object({
  businessHours: z.array(ApiBusinessDay),
  timezone: z.string(),
  main_city: z.string()
})

const ApiGetBranchBusinessHoursSchema = z.object({
  store_id: z.string(),
  cityBusinessHours: z.array(ApiBusinessDayResponse).nullable(),
  businessHours: z.array(ApiBusinessDay),
  timezone: z.string(),
  main_city: z.string()
})

const ApiSetBusinessHoursSchema = z.object({
  cityBusinessHours: z.array(ApiBusinessDayResponse).nullable(),
  message: z.string(),
  status: z.number().nullable()
})

const DTOBusinessHoursSchema = ApiGetBusinessHoursSchema.pick({
  businessHours: true
})

const ApiGetPreparationTimeSchema = z.object({
  range: z.object({
    min: z.number().nullable(),
    max: z.number().nullable()
  })
})

export {
  ApiBusinessDayResponse,
  ApiGetBranchBusinessHoursSchema,
  ApiGetBusinessHoursSchema,
  ApiGetPreparationTimeSchema,
  ApiGetProfileResponseSchema,
  ApiProfileDataSchema,
  ApiSetBusinessHoursSchema,
  DTOBusinessHoursSchema
}
